import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { NotificationClient } from "../../parentApi";

const client = new NotificationClient(app_uri, axiosClient());

export default client;
